<template>
    <div class="add-ccxs">
        <my-title the-title="财产线索"/>
        <div class="fd-com-warning-tip">
            温馨提示：若您未找到相应的财产类型或未明确具体的财产线索时，请选择【其他】
        </div>
            <van-cell-group class="fd-com-scroll">
                <van-field
                    v-model="formData.cCclxText"
                    class="special-readonly"
                    required
                    clearable
                    readonly
                    label="财产类型"
                    right-icon="arrow"
                    placeholder="请选择财产类型"
                    @click="showCCLX = true"
                ></van-field>
                <van-popup v-model="showCCLX" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="codeList_112000"
                        :default-index="0"
                        @cancel="showCCLX = false"
                        @confirm="onCCLXConfirm"
                    ></van-picker>
                </van-popup>
                <!--保全开始日期-->
                <van-field
                    v-model="formData.dBqksrq"
                    class="special-readonly"
                    required
                    clearable
                    readonly
                    label="保全开始日期"
                    right-icon="arrow"
                    placeholder="请选择保全开始日期"
                    @click="showBqksrq = true"
                ></van-field>
                <van-popup v-model="showBqksrq" position="bottom">
                    <van-datetime-picker v-model="bqksrqCurrentDate" type="date" @confirm="onBqrqConfirm('1')" @cancel="onBqrqcancelFn('1')" />
                </van-popup>
                <!-- 保全结束日期-->
                <van-field
                    v-model="formData.dBqjsrq"
                    class="special-readonly"
                    required
                    clearable
                    readonly
                    label="保全结束日期"
                    right-icon="arrow"
                    placeholder="请选择保全结束日期"
                    @click="showBqjsrq = true"
                ></van-field>
                <van-popup v-model="showBqjsrq" position="bottom">
                    <van-datetime-picker v-model="bqjsrqCurrentDate" type="date"  @confirm="onBqrqConfirm('2')" @cancel="onBqrqcancelFn('2')" />
                </van-popup>
                <van-field
                    v-model="formData.cMs"
                    required
                    clearable
                    label="描述"
                    placeholder="请输入描述"
                ></van-field>
            </van-cell-group>
            <div class="fd-com-btn-container">
                <van-button
                    v-if="formData.bqCcxsId"
                    type="info"
                    round
                    plain
                    :disabled="!saveBtnClickable"
                    @click="addCcxsAndReturn"
                >
                    确定
                </van-button>
                <van-button
                    v-if="!formData.bqCcxsId"
                    type="info"
                    round
                    plain
                    :disabled="!saveBtnClickable"
                    @click="addCcxsAndReturn"
                >
                    添加
                </van-button>
                <!--财产id有值时是编辑状态, 编辑只显示一个确定按钮-->
                <van-button
                    v-if="!formData.bqCcxsId"
                    type="info"
                    round
                    :disabled="!saveBtnClickable"
                    @click="addCcxsAndContinue"
                >
                    确认并继续添加
                </van-button>
            </div>
    </div>
</template>

<script>
import MyTitle from '../../../components/common/myTitle';
import {
    typeCclx, typeXwbqsx,
} from '../../../filters/index';
import validate from '@/utils/validator/validator';
import {
    cclxRule,
    dBqksrqRule, dBqjsrqRule, csxsmRule
} from '@/utils/validator/rules';
import {mapGetters} from 'vuex'
import {saveXxbqData} from "@/api/guarantee";
import {getId} from "@/api/common";
export default {
    components: {
        MyTitle
    },
    data() {
        return {
            cCclx: 4, // 财产类型
            cCclxText: '房产',
            showCCLX: false, // 财产类型
            // showBZLX: false, // 币种类型
            // showCLLX: false, // 车辆类型
            // showTDDW: false, // 土地单位类型
            // showCCSYR: false, // 财产所属人员
            // showKhhszd:false, //开户行所在地
            // columnsBSQRS: [],
            bqksrqCurrentDate: new Date(),
            bqjsrqCurrentDate: new Date(),
            showBqksrq:false,
            showBqjsrq:false,
            formData: {
                bqCcxsId: '',
                cCclx: '',
                dBqksrq:'',
                dBqjsrq:'',
                cMs: "",
                cXbid:null,
                cBqid:null,
                cId: null
            },
            cclxCode: 4,
            saveBtnClickable: true, // 保存按钮是否可以点击
        }
    },
    computed: {
        ...mapGetters(['codeList_112000','xxbqccxsData', 'xxbqdbxxData']),
    },
    methods: {
        params() {
            let xbJbxx = [];
            let xxbqccxs = [];
            let xxDbxxs = [];
            xxDbxxs = this.xxbqdbxxData;
            console.log(this.xxbqccxsData)
            if (this.xxbqccxsData.length > 0 ) {
                xxbqccxs = this.xxbqccxsData
            }
            // alert(typeof this.formData)
            xxbqccxs.push(this.formData)
            xbJbxx = JSON.parse(sessionStorage.getItem('xxbqjbxx'))
            return {
                dbJbxxs: xxDbxxs,
                xbJbxx: xbJbxx,
                xbCcxxs: xxbqccxs,
                xbZjxxs: [],
                xbXwxxs: [],
            }
        },
        onBqrqcancelFn(item) {
            if (item === '1') {
                this.showBqksrq = false;
            }
            if (item === '2') {
                this.showBqjsrq = false;
            }
        },
        onBqrqConfirm: function(item){
            if (item === '1') {
                this.formData.dBqksrq = this.timeFormat(this.bqksrqCurrentDate);
                this.showBqksrq = false;
            }
            if (item === '2') {
                this.formData.dBqjsrq = this.timeFormat(this.bqjsrqCurrentDate);
                this.showBqjsrq = false;
            }
        },
        /*开户行所在地的省份*/
        // confirmKhhszd(item){
        //     this.showKhhszd = false;
        //     this.formData.cKhhszd = item.keyId;
        //     this.formData.cKhhszdText = item.text;
        // },
        onCCLXConfirm: function (item) {
            // this.clearCCXSData();
            // // if (5 == item.keyId) {
            // //     this.formData.cYhckzckdw = 1;
            // //     this.formData.cYhckzckdwText = "平方米";
            // // }
            // this.initCCXSData(sessionStorage.getItem("bqCcxsId"));
            this.showCCLX = false;
            this.formData.cCclx = item.keyId;
            this.formData.cCclxText = item.text;
            this.cclxCode = item.keyId;
        },
        async onSubmit(fn){
            let params = await this.params()
            this.formData.cXbid = this.$route.query.cId;
            this.formData.cBqid = this.$route.query.bqid;
            this.formData.checked = true;
            var bqCcxsId = sessionStorage.getItem("bqCcxsId");
            if (bqCcxsId) {
                this.formData.cId = bqCcxsId;
            } else {
                this.formData.cId = await this.myId(0);
            }
            console.log('--数据提交 111',this.formData,params);
            this.validateFormData().then(() => {
                saveXxbqData(params).then((res)=>{
                    console.log('--addXcxXw 123',res);
                    if (res.code ===200) {
                        this.$notify({'type': 'success', 'message': '操作成功'});
                    } else {
                        this.$notify(res.message);
                    }
                    fn();
                }).catch((error) => {  console.log(error) });
            });
        },
        addCcxsAndReturn: function () {
            this.onSubmit(()=>{
                this.$router.push({
                    path: '/continuationPreservationNew',
                    query: {
                        bqid: this.$route.query.bqid,
                        cId: this.$route.query.cId,
                    }
                })
            });
        },
        addCcxsAndContinue: function () {
            const validated = this.validateFormData();
            validated.then(() => {
                this.onSubmit().then(() => {
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                });
            });
        },
        clearCCXSData: function () {
            let formData = this.formData;
            for (let key in formData) {
                if (key != "cBqId") {
                    formData[key] = '';
                }
            }
        },
        validateFormData(){
            // 校验规则
            let descriptor={};
            descriptor.cCclx = cclxRule;
            descriptor.dBqksrq = dBqksrqRule;
            descriptor.dBqjsrq = dBqjsrqRule;
            descriptor.cMs = csxsmRule;
            return validate(descriptor, this.formData);
        },
        initCodeType(){
            this.$store.dispatch('GetCodeType', 112000)
        },
        timeFormat(time) { // 时间格式化 2019-09-08
            let year = time.getFullYear();
            let month = time.getMonth() + 1;
            let day = time.getDate();
            return year + '-' + month + '-' + day
        },
        /**
         * 获取id
         * */
        myId(i) {
            return new Promise((resolve, reject) => {
                i++
                if (i > 3) {
                    this.$notify('系统错误，请重试!');
                    reject();
                } else {
                    getId().then((res) => {
                        resolve(res.data)
                    }).catch(() => {
                        return this.myId(i);
                    })
                }
            })
        },
        initData(){
            var data=this.formData;
            this.formData.cCclx=data.cCclx;
            this.formData.cCclxText=typeCclx(data.cCclx);
        },
    },
    created() {
        this.initCodeType()
        let bqCcxsId = sessionStorage.getItem("bqCcxsId");
        var xxccxItem = sessionStorage.getItem("xxccxsItem");
        // this.formData.cBqppid = bqCcxsId;
        if(xxccxItem){
            this.formData = JSON.parse(xxccxItem);
            this.formData.bqCcxsId = bqCcxsId;
            this.initData();
        }
        // let currentBqid = JSON.parse(sessionStorage.getItem("currentBqid"));
        // this.formData.cBqId = currentBqid;
        // this.initColumnsBSQRS()
    },
    mounted() {
        this.timeFormat(new Date());
    },
    // 路由跳转之前保存当前滚动条的位置。
    beforeRouteLeave(to, from, next) {
        sessionStorage.removeItem("xxccxsItem");
        sessionStorage.removeItem("bqCcxsId");
        next();
    },
}
</script>
